import { ToastController } from '@ionic/angular';

export class ToastUtils {
    private static toastCtrl: ToastController;

    static init(toastCtrl: ToastController) {
        this.toastCtrl = toastCtrl;
    }

    static async success(message: string) {
        return this.showToast(message, 'success');
    }

    static async error(message: string) {
        return this.showToast(message, 'danger');
    }

    private static async showToast(message: string, color: 'success' | 'danger') {
        if (!this.toastCtrl) {
            console.error('Toast controller not initialized');
        }
        const toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            color,
        });
        return toast.present();
    }
}
